import React from "react";
import { ChevronDown } from "lucide-react";

export default function PublicSeoFaq({ faqs, title = "Frequently asked questions" }) {
  const [openIndex, setOpenIndex] = React.useState(0);

  return (
    <section className="rounded-[2rem] border border-border bg-muted/35 p-6 md:p-10">
      <p className="text-sm font-black uppercase tracking-[0.22em] text-primary">FAQ</p>
      <h2 className="mt-2 font-heading text-3xl font-black">{title}</h2>
      <div className="mt-6 overflow-hidden rounded-3xl border border-border bg-card shadow-sm">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={faq.question} className="border-b border-border last:border-b-0">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-muted/45 md:px-6"
              >
                <span className="font-black text-foreground">{faq.question}</span>
                <ChevronDown className={`h-5 w-5 shrink-0 text-primary transition-transform ${isOpen ? "rotate-180" : ""}`} />
              </button>
              {isOpen && (
                <div className="border-t border-border bg-background/70 px-5 py-5 md:px-6">
                  <p className="max-w-3xl leading-8 text-muted-foreground">{faq.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}